import { E_LABS_NAME } from '@/domains/lab/enums';
import { LabService } from '@/domains/lab/lab-service';
import { injectService } from '@/inversify.config';
import { createSharedComposable } from '@vueuse/core';
import _ from 'lodash';
import { computed, ref } from 'vue';
export const useLab = createSharedComposable(() => {
    const labService = injectService(LabService);
    const labAnchorMap = ref(null);
    labService.labModal.subscribeLabAnchorMap((newVal) => {
        labAnchorMap.value = newVal;
    });
    const enableLabPatentColor = computed(() => {
        return _.get(labAnchorMap.value, `${E_LABS_NAME.PATENT_COLOR}.used`, false);
    });
    const enableLabPatentWordCloud = computed(() => {
        return _.get(labAnchorMap.value, `${E_LABS_NAME.PATENT_WORD_CLOUD}.used`, false);
    });
    const enableLabWorkspaceLiteTable = computed(() => {
        return _.get(labAnchorMap.value, `${E_LABS_NAME.WORKSPACE_LITE_TABLE}.used`, false);
    });
    const enableLabDeepView = computed(() => {
        // return _.get(labAnchorMap.value, `${E_LABS_NAME.DEEP_VIEW}.used`, false) as boolean;
        return true;
    });
    const enableLabHiResImage = computed(() => {
        return _.get(labAnchorMap.value, `${E_LABS_NAME.HI_RES_IMAGE}.used`, false);
    });
    const initLabModal = () => {
        return labService.initLabModal();
    };
    const getAnchorItem = (anchor) => {
        return labService.getAnchorItem(anchor);
    };
    return {
        enableLabPatentColor,
        enableLabPatentWordCloud,
        enableLabWorkspaceLiteTable,
        enableLabDeepView,
        enableLabHiResImage,
        initLabModal,
        getAnchorItem,
    };
});
